import { render, staticRenderFns } from "./InduksiViewEmail.vue?vue&type=template&id=678da478&scoped=true&lang=pug&"
import script from "./InduksiViewEmail.vue?vue&type=script&lang=js&"
export * from "./InduksiViewEmail.vue?vue&type=script&lang=js&"
import style0 from "./InduksiViewEmail.vue?vue&type=style&index=0&id=678da478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678da478",
  null
  
)

export default component.exports